import CheckMarkIcon from '@/assets/icons/CheckMarkIcon';
import { Container, Typography } from '@pwskills/rachnaui';
import useMasterclassDescriptionStore from '@/store/MasterClassDescription/useMasterclasDescriptionStore';
import { IMasterclassDescription } from '@/interfaces/masterclassDescription';
import { useRouter } from 'next/router';
import { randomId } from '@pwskills/rachnaui/utils';
import MasterclassHeader from '../MasterclassHeader';

const WhatYouWillLearnSection = () => {
  const masterclassDetails = useMasterclassDescriptionStore(
    (state: { masterclassDetails: IMasterclassDescription }) => state.masterclassDetails
  );
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  const whatYouWillLearn = masterclassDetails?.whatYouWillLearn || [];

  return (
    <div className={`${isDashboard ? '' : 'bg-blue-50'} w-full`}>
      <Container
        id="category-hero-section"
        className={`${
          isDashboard
            ? 'medium:!px-12 !pt-9 medium:!pb-6 medium:!pr-0 px-4 large:!px-8'
            : '!py-6 medium:!py-8 large:!py-14  !px-4 medium:!px-8 large:!px-20'
        } flex flex-col`}
      >
        <div className="flex flex-col gap-4 large:!gap-14">
          <MasterclassHeader
            headerText="What You Will Learn In This Master Class ?"
            className={isDashboard ? 'text-left' : 'text-center'}
          />

          {/* gap-4 is removed and made it justify-between */}
          <div className="flex flex-col medium:flex-row w-full medium:flex-wrap gap-4">
            {whatYouWillLearn.map((item) => {
              return (
                <div
                  className={`${
                    isDashboard ? 'large:!w-[47%] gap-4' : 'large:!w-[32.35%] gap-3'
                  } 'flex flex-col  !w-full medium:!w-[48%]  gap-3`}
                  key={randomId()}
                >
                  <Typography
                    component={isDashboard ? 'body-regular' : 'subheading'}
                    variant="bold"
                    className={`${
                      isDashboard ? 'text-[16px]' : '!text-[18px]'
                    } 'py-1 pr-4 !leading-[26px] border-b border-stroke-300'`}
                  >
                    {item.title}
                  </Typography>
                  {item.pointers.map((pointer) => {
                    return (
                      <div className="flex gap-2 py-2 pr-4" key={randomId()}>
                        <div className="w-5 h-5">
                          <CheckMarkIcon color="#3E8E2A" />
                        </div>
                        <Typography
                          component="body-regular"
                          variant="semi-bold"
                          className={`${
                            isDashboard ? 'text-gray-850' : 'text-gray-850'
                          } !text-[16px] !leading-[24px]`}
                        >
                          {pointer}
                        </Typography>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default WhatYouWillLearnSection;
